import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiBaseUrl } from '../lib/env';

const ERROR_MESSAGES: Record<string, string> = {
  state_mismatch: '登入流程驗證失敗，請重試。',
  code_invalid: 'Google 授權無效，請重試。',
  forbidden: '此 Email 未授權使用本系統。',
};

export function LoginPage() {
  const { status } = useAuth();
  const [params, setParams] = useSearchParams();
  const errorCode = params.get('error');

  useEffect(() => {
    // 清掉錯誤 param 避免重整時還顯示
    if (errorCode) {
      const t = setTimeout(() => {
        setParams({});
      }, 8000);
      return () => clearTimeout(t);
    }
  }, [errorCode, setParams]);

  // 已登入：跳回首頁
  if (status === 'authed') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm rounded-lg border bg-white p-8 shadow-sm">
        <h1 className="mb-1 text-center text-2xl font-bold text-gray-900">
          想印就印
        </h1>
        <p className="mb-6 text-center text-sm text-gray-500">PAYUNi 收款管家</p>

        {errorCode && (
          <div className="mb-4 rounded border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700">
            {ERROR_MESSAGES[errorCode] ?? `登入失敗：${errorCode}`}
          </div>
        )}

        <a
          href={`${apiBaseUrl()}/api/auth/google`}
          className="flex w-full items-center justify-center gap-2 rounded border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"
              fill="#EA4335"
            />
          </svg>
          使用 Google 登入
        </a>

        <p className="mt-6 text-center text-xs text-gray-400">
          僅授權白名單內的管理員帳號
        </p>
      </div>
    </div>
  );
}
